import { ConvertedFile } from './FileInput';

export const isSingleFile = (files: ConvertedFile[] | ConvertedFile): files is ConvertedFile =>
  (files as ConvertedFile).name !== undefined;
